export function isEmprty(value){
    if(value === '' || value === null || value === 'undefined' ){
        return true
    }else{
        return false
    }
}
export function isNumber(value){
    if(!value && isNaN(Number(value)) ){
        return false
    }else{
        return true
    }
}
export function isPhone(value){
    let pattern = /^[0-9()+-\s_]*$/
    if(value && pattern.test(value)){
        return true
    }else{
        return false
    }
}
export function isPrice(value){
    let pattern =  /^\d+(\.\d{1,2})?$/
    if(value && pattern.test(value)){
        return true
    }else{
        return false
    }
}